import React, { useState } from "react";

export default function OptionchainData(props) {
  const dateType = props.dateType;
  const getDetails = props.getDetails;
  const [vals, setvals] = useState(0);
  const chnageType = (event) => {
    let newval = vals !== "item" + event ? "item" + event : "";
    setvals(newval);
  };
  return (
    <>
      <table className="table" style={{ marginBottom: "0" }}>
        {dateType === "both" && (
          <tbody>
            <tr>
              <td colSpan="4" className="text-center">
                <button className="btn btn-lg btn-success">Calls</button>
              </td>
              <td colSpan="4" className="text-center">
                <button className="btn btn-danger"> Puts</button>
              </td>
            </tr>
          </tbody>
        )}
      </table>
      <table className="table table-bordered custom-option-table">
        <thead>
          <tr>
            {dateType === "both" && (
              <>
                <th>OI</th>
                <th className="text-center">Vol</th>
                <th className="text-center">LTP</th>
                <th className="text-center">Strike</th>
                <th className="text-center">LTP</th>
                <th className="text-center">Vol</th>
                <th className="text-center">OI</th>
              </>
            )}
          </tr>
        </thead>

        {getDetails && dateType === "both"
          ? getDetails.map((item, key) => (
              <tbody key={key}>
                <tr>
                  <td
                    className={
                      item.ceoiper >= 0
                        ? item.ceoiper === 0
                          ? ""
                          : "greenTxt"
                        : "redTxt"
                    }
                  >
                    {item.ceoi} <br />({item.ceoiper}%)
                  </td>
                  <td className="text-center">{item.cevol}</td>
                  <td
                    className={
                      item.ceper > 0
                        ? "greenTxt text-center"
                        : "redTxt text-center"
                    }
                  >
                    {item.celtp} <br />({parseFloat(item.ceper).toFixed(2)})
                  </td>

                  <td
                    className="text-center"
                    onClick={(event) => chnageType(key)}
                  >
                    <label className="strikeprice">{item.strike_prcie}</label>
                  </td>

                  <td
                    className={
                      item.peper > 0
                        ? "greenTxt text-center"
                        : "redTxt text-center"
                    }
                  >
                    {parseFloat(item.peltp).toFixed(2)} <br />(
                    {parseFloat(item.peper).toFixed(2)})
                  </td>
                  <td className="text-center">{item.pevol}</td>
                  <td
                    className={
                      item.peoiper >= 0
                        ? item.peoiper === 0
                          ? "text-center"
                          : "greenTxt text-center"
                        : "redTxt text-center"
                    }
                  >
                    {item.peoi}
                    <br />({parseFloat(item.peoiper).toFixed(2)}%)
                  </td>
                </tr>
                <tr
                  style={{
                    display: vals === "item" + key ? "table-row" : "none",
                  }}
                >
                  <td colSpan="7" className="tagetbox">
                    <div className="row">
                      <div className="col-sm-6 text-center border-right">
                        <div className="row">
                          <div className="col-sm-12 text-center">
                            <button className="btn btn-customblock">
                              <div className="width50">
                                <label className="font-bold">PP : </label>
                                <label
                                  className={
                                    item.pp < 0 ? "txtRed" : "txtGreen"
                                  }
                                >
                                  {parseFloat(item.pp).toFixed(2)}
                                </label>
                              </div>
                            </button>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">S1: </label>
                              <label
                                className={
                                  item.sone < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.sone).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-left">
                            <div className="width50">
                              <label className="font-bold">R1 : </label>
                              <label
                                className={
                                  item.rone < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.rone).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">S2: </label>
                              <label
                                className={
                                  item.stwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.stwo).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-left">
                            <div className="width50">
                              <label className="font-bold">R2 : </label>
                              <label
                                className={
                                  item.rtwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.rtwo).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">S3: </label>
                              <label
                                className={
                                  item.sthree < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.sthree).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-left">
                            <div className="width50">
                              <label className="font-bold">R3 : </label>
                              <label
                                className={
                                  item.rthree < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.rthree).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-12 text-center pt-2">
                            <button className="btn btn-customblock">
                              <label className="font-bold">Buy Above :</label>
                              <label
                                className={
                                  item.rtwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.buyAbove).toFixed(2)}
                              </label>
                            </button>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T1 : </label>
                              <label
                                className={
                                  item.rtwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.tone).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6  text-left">
                            <div className="width50">
                              <label className="font-bold">SL :</label>
                              <label
                                className={
                                  item.rtwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.sellBelow).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T2 : </label>
                              <label
                                className={
                                  item.rtwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.ttwo).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6  text-left">
                            <div className="width50">
                              <label className="font-bold">Support:</label>
                              <label
                                className={
                                  item.suppport < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.suppport).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T3 : </label>
                              <label
                                className={
                                  item.tthree < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.tthree).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1"></div>

                          <div className="col-sm-12 text-center pt-2 pb-2">
                            <button className="btn btn-customblock">
                              <label className="font-bold ">Sell Below :</label>
                              <label
                                className={
                                  item.sellBelow < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.sellBelow).toFixed(2)}
                              </label>
                            </button>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T1 : </label>
                              <label
                                className={
                                  item.sttone < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.sttone).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-left">
                            <div className="width50">
                              <label className="font-bold">SL : </label>
                              <label
                                className={
                                  item.buyAbove < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.buyAbove).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T2 : </label>
                              <label
                                className={
                                  item.sttwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.sttwo).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-left">
                            <div className="width50">
                              <label className="font-bold">Resistance :</label>
                              <label
                                className={
                                  item.resistance < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.resistance).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T3 : </label>
                              <label
                                className={
                                  item.stthree < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.stthree).toFixed(2)}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6 text-center">
                        <div className="row">
                          <div className="col-sm-12 text-center pb-2">
                            <button className="btn btn-customblock">
                              <label className="font-bold">PP: </label>
                              <label
                                className={
                                  item.pepp < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pepp).toFixed(2)}
                              </label>
                            </button>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">S1 : </label>
                              <label
                                className={
                                  item.pesone < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pesone).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-left">
                            <div className="width50">
                              <label className="font-bold">R1 : </label>
                              <label
                                className={
                                  item.perone < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.perone).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">S2 : </label>
                              <label
                                className={
                                  item.pestwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pestwo).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-left">
                            <div className="width50">
                              <label className="font-bold">R2 : </label>
                              <label
                                className={
                                  item.pertwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pertwo).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">S3 : </label>
                              <label
                                className={
                                  item.pesthree < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pesthree).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-left">
                            <div className="width50">
                              <label className="font-bold">R3 : </label>
                              <label
                                className={
                                  item.perthree < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.perthree).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-12 text-center">
                            <button className="btn btn-customblock ">
                              <label className="font-bold">Buy Above :</label>
                              <label
                                className={
                                  item.pertwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pebuyAbove).toFixed(2)}
                              </label>
                            </button>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T1 : </label>
                              <label
                                className={
                                  item.pertwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.petone).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6  text-left">
                            <div className="width50">
                              <label className="font-bold">SL : </label>
                              <label
                                className={
                                  item.pertwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pesellBelow).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T2 : </label>
                              <label
                                className={
                                  item.pertwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pettwo).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6  text-left">
                            <div className="width50">
                              <label className="font-bold">Support : </label>
                              <label
                                className={
                                  item.pesuppport < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pesuppport).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T3 : </label>
                              <label
                                className={
                                  item.petthree < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.petthree).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1"></div>

                          <div className="col-sm-12 text-center pt-2 pb-2">
                            <button className="btn  btn-customblock">
                              <label className="font-bold ">Sell Below :</label>
                              <label
                                className={
                                  item.pesellBelow < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pesellBelow).toFixed(2)}
                              </label>
                            </button>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T1 : </label>
                              <label
                                className={
                                  item.pesttone < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pesttone).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-left">
                            <div className="width50">
                              <label className="font-bold">SL : </label>
                              <label
                                className={
                                  item.pebuyAbove < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pebuyAbove).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T2 : </label>
                              <label
                                className={
                                  item.pesttwo < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pesttwo).toFixed(2)}
                              </label>
                            </div>
                          </div>
                          <div className="col-sm-6 col-xs-6 col-lg-6 text-left">
                            <div className="width50">
                              <label className="font-bold">Resistance : </label>
                              <label
                                className={
                                  item.peresistance < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.peresistance).toFixed(2)}
                              </label>
                            </div>
                          </div>

                          <div className="col-sm-6 col-xs-6 col-lg-6 text-right1">
                            <div className="width50">
                              <label className="font-bold">T3 : </label>
                              <label
                                className={
                                  item.pestthree < 0 ? "txtRed" : "txtGreen"
                                }
                              >
                                {parseFloat(item.pestthree).toFixed(2)}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            ))
          : ""}
      </table>

      {dateType === "ce" && (
        <>
          <div className="row">
            <div className="col-sm-2 "></div>
            <div className="col-sm-8">
              <div className="row" style={{ marginBottom: "0" }}>
                <div className="col-sm-12 text-center">
                  <button className="btn btn-lg btn-success">Calls</button>
                  <hr />
                </div>
              </div>
              <div className="row customrow  pt-2 pb-2 btn-primary adv-border">
                <div className="colsm-2 font-bold">Strike</div>
                <div className="colsm-2 font-bold">Open</div>
                <div className="colsm-2 font-bold">High</div>
                <div className="colsm-2 font-bold">Low</div>
                <div className="colsm-2 font-bold">Close</div>
              </div>
              {getDetails &&
                getDetails.map((item, key) => (
                  <div className="option-chain-box" key={key}>
                    <div className="row customrow">
                      <div className="colsm-2">
                        {parseFloat(item.strike_prcie).toFixed(2)}
                      </div>
                      <div className="colsm-2">
                        {parseFloat(item.ceop).toFixed(2)}
                      </div>
                      <div className="colsm-2">
                        {parseFloat(item.cehi).toFixed(2)}
                      </div>
                      <div className="colsm-2">
                        {parseFloat(item.celo).toFixed(2)}
                      </div>
                      <div className="colsm-2">
                        {parseFloat(item.cecls).toFixed(2)}
                      </div>
                    </div>
                    <div className="row customrow">
                      <div className="colsm-2">
                        <label className>
                          <label className="font-bold">Vol :</label>
                          {item.cevol}
                        </label>
                      </div>
                      <div className="colsm-2"></div>
                      <div
                        className={
                          item.ceoiper >= 0
                            ? "greenTxt colsm-2"
                            : "redTxt colsm-2"
                        }
                      >
                        <label className>
                          <label className="font-bold"> OI:</label>
                          {item.ceoi} ({item.ceoiper}%)
                        </label>
                      </div>
                      <div className="colsm-2"></div>
                      <div className="colsm-2">
                        {parseFloat(item.ceval_inlakh).toFixed(2)}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}

      {dateType === "pe" && (
        <>
          <div className="row">
            <div className="col-sm-2 "></div>
            <div className="col-sm-8">
              <div className="row" style={{ marginBottom: "0" }}>
                <div className="col-sm-12 text-center">
                  <button className="btn btn-lg btn-danger">Puts</button>
                  <hr />
                </div>
              </div>
              <div className="row customrow pt-2 pb-2 btn-primary adv-border">
                <div className="colsm-2 font-bold">Strike</div>
                <div className="colsm-2 font-bold">Open</div>
                <div className="colsm-2 font-bold">High</div>
                <div className="colsm-2 font-bold">Low</div>
                <div className="colsm-2 font-bold">Close</div>
              </div>

              {getDetails &&
                getDetails.map((item, key) => (
                  <div className="option-chain-box" key={key}>
                    <div className="row customrow">
                      <div className="colsm-2">
                        {parseFloat(item.strike_prcie).toFixed(2)}
                      </div>
                      <div className="colsm-2">
                        {parseFloat(item.peop).toFixed(2)}
                      </div>
                      <div className="colsm-2">
                        {parseFloat(item.pehi).toFixed(2)}
                      </div>
                      <div className="colsm-2">
                        {parseFloat(item.pelo).toFixed(2)}
                      </div>
                      <div className="colsm-2">
                        {parseFloat(item.pecls).toFixed(2)}
                      </div>
                    </div>
                    <div className="row customrow">
                      <div className="colsm-2">
                        <label className>Vol : {item.pevol}</label>
                      </div>
                      <div className="colsm-2"></div>
                      <div
                        className={
                          item.peoi >= 0 ? "greenTxt colsm-2" : "redTxt colsm-2"
                        }
                      >
                        <label className>
                          OI:{item.peoi} ({item.peoiper}%)
                        </label>
                      </div>
                      <div className="colsm-2"></div>
                      <div className="colsm-2">
                        {parseFloat(item.peval_inlakh).toFixed(2)}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
    </>
  );
}
